module.exports = __webpack_public_path__ + "static/media/complete-filled.d0cf9449.svg";